(ns yardwerkz.web.booking.pricing
  "Step 6: Pricing tier selection (budget / standard / premium)."
  (:require
   [uix.core :refer [defui $ use-state use-callback]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.ui.icons :as icons]))

(def ^:private tiers
  [{:id "budget"
    :label "Budget"
    :price "$40–50"
    :desc "Basic service, best value"
    :icon icons/DollarSign
    :features ["Standard equipment" "Next-day availability"]}
   {:id "standard"
    :label "Standard"
    :price "$60–75"
    :desc "Recommended for most yards"
    :icon icons/CheckCircle
    :badge "Popular"
    :features ["Pro equipment" "Same-day available" "Photo documentation"]}
   {:id "premium"
    :label "Premium"
    :price "$90+"
    :desc "Top-rated pros, priority service"
    :icon icons/Zap
    :features ["Premium equipment" "Priority scheduling" "Before/after photos" "Satisfaction guarantee"]}])

(defui pricing-step [{:keys [on-next on-back]}]
  (let [dispatch (rfx/use-dispatch)
        saved-pricing (rfx/use-sub [::store/draft-pricing])
        [selected set-selected] (use-state (get saved-pricing :tier "standard"))

        persist!
        (use-callback
         (fn [tier]
           (let [tier-data (some #(when (= (:id %) tier) %) tiers)]
             (dispatch [::store/set-pricing {:tier tier
                                             :display-price (:price tier-data)}])))
         [dispatch])]

    ($ :div {:class "space-y-4"}
       ($ :h2 {:class "text-lg font-semibold text-gray-900"} "Choose your pricing tier")

       ($ :div {:class "grid grid-cols-1 md:grid-cols-3 gap-4"}
          (for [{:keys [id label price desc icon badge features]} tiers]
            (let [is-selected (= selected id)]
              ($ :div {:key id
                       :class (str "relative flex flex-col p-6 rounded-xl border-2 transition-all cursor-pointer "
                                   (if is-selected
                                     "border-green-500 bg-green-50 shadow-md"
                                     "border-gray-200 hover:border-green-300 hover:bg-gray-50"))
                       :on-click (fn []
                                   (set-selected id)
                                   (persist! id))}
                 ;; Popular badge
                 (when badge
                   ($ :span {:class "absolute -top-2.5 left-1/2 -translate-x-1/2 bg-green-600 text-white text-xs font-medium px-2.5 py-0.5 rounded-full"}
                      badge))

                 ;; Icon + label
                 ($ :div {:class "flex items-center space-x-3 mb-3"}
                    ($ :div {:class (str "w-10 h-10 rounded-full flex items-center justify-center "
                                         (if is-selected "bg-green-100" "bg-gray-100"))}
                       ($ icon {:size 20 :class (if is-selected "text-green-600" "text-gray-500")}))
                    ($ :div
                       ($ :p {:class "font-semibold text-gray-900"} label)
                       ($ :p {:class "text-lg font-bold text-green-600"} price)))

                 ($ :p {:class "text-sm text-gray-500 mb-4"} desc)

                 ;; Features
                 ($ :ul {:class "space-y-1.5"}
                    (for [feature features]
                      ($ :li {:key feature
                              :class "flex items-center space-x-2 text-sm text-gray-700"}
                         ($ icons/Check {:size 14 :class "text-green-500"})
                         ($ :span feature))))

                 ;; Selected indicator
                 (when is-selected
                   ($ :div {:class "absolute top-4 right-4"}
                      ($ icons/CheckCircle {:size 20 :class "text-green-600"}))))))))))
